module.exports = __webpack_public_path__ + "img/icon-lightbulb.25f00790.svg";